import CategoryList from "./CategoryList";

export default {
    list: CategoryList
}